module.exports = __webpack_public_path__ + "assets/bf2a63762fcaa016a1d6b26f38e4aaa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/default-cover.jpg
// module id = 884
// module chunks = 0